/**
 * Handles showing/hiding metafield images based on variant selection
 * Works with the hide_variants setting in product-media-gallery
 */

(function() {
  'use strict';

  // Store the last processed variant ID to avoid duplicate processing
  let lastProcessedVariantId = null;

  function handleVariantChange(event) {
    const { data } = event;
    let variantId = null;

    // Try to get variant ID from different event structures
    if (data?.variant?.id) {
      // variantChange event: { data: { sectionId, html, variant } }
      variantId = data.variant.id;
      console.log('[Metafield Images] variantChange event - Variant ID:', variantId);
    } else if (data?.selectedOptionValues) {
      // optionValueSelectionChange event: { data: { event, target, selectedOptionValues } }
      // We need to find the variant that matches these option values
      const sectionId = data.target?.closest('variant-selects, variant-radios')?.dataset?.section;
      if (sectionId) {
        const productInfo = document.querySelector(`product-info[data-section="${sectionId}"]`);
        if (productInfo) {
          // Find all variant data scripts - there may be multiple
          const variantScripts = productInfo.querySelectorAll('script[type="application/json"]');

          for (let script of variantScripts) {
            try {
              const parsedData = JSON.parse(script.textContent);
              console.log('[Metafield Images] Parsed variant data:', parsedData);

              // Check if it's an array of variants
              let variants = Array.isArray(parsedData) ? parsedData : null;

              // If not an array, check if it's a single variant object
              if (!variants && parsedData.id && parsedData.options) {
                // Single variant object
                variants = [parsedData];
              }

              if (variants && variants.length > 0) {
                // Find variant matching selected options
                const selectedOptions = data.selectedOptionValues;
                console.log('[Metafield Images] Looking for variant matching options:', selectedOptions);

                const matchingVariant = variants.find(v => {
                  if (!v.options || !Array.isArray(v.options)) return false;
                  return v.options.every((opt, index) => opt === selectedOptions[index]);
                });

                if (matchingVariant) {
                  variantId = matchingVariant.id;
                  console.log('[Metafield Images] optionValueSelectionChange event - Found matching variant:', variantId);
                  break; // Found it, exit the loop
                }
              }
            } catch (e) {
              console.warn('[Metafield Images] Error parsing variant data from script:', e);
            }
          }
        }
      }
    }

    if (!variantId) {
      console.warn('[Metafield Images] Could not determine variant ID from event');
      return;
    }

    // Avoid processing the same variant twice in rapid succession
    if (variantId === lastProcessedVariantId) {
      console.log('[Metafield Images] Skipping duplicate event for variant:', variantId);
      return;
    }
    lastProcessedVariantId = variantId;

    console.log('[Metafield Images] Processing variant change to:', variantId);

    // Get all media galleries on the page (main product and featured product)
    const mediaGalleries = document.querySelectorAll('media-gallery');
    console.log('[Metafield Images] Found galleries:', mediaGalleries.length);

    mediaGalleries.forEach((gallery) => {
      updateMetafieldImages(gallery, variantId);
    });
  }

  function updateMetafieldImages(gallery, variantId) {
    // Get all metafield images and thumbnails in the gallery
    const metafieldImages = gallery.querySelectorAll('[data-metafield-image="true"]');
    console.log('[Metafield Images] Found metafield images:', metafieldImages.length);
    console.log('[Metafield Images] Looking for variant ID:', variantId, 'Type:', typeof variantId);

    metafieldImages.forEach((image) => {
      const imageVariantId = image.dataset.variantId;
      console.log('[Metafield Images] Comparing - Image variant ID:', imageVariantId, 'Type:', typeof imageVariantId, 'Selected variant ID:', variantId, 'Type:', typeof variantId, 'Match:', imageVariantId === String(variantId));

      if (imageVariantId === String(variantId)) {
        // Show images for the selected variant
        console.log('[Metafield Images] ✓ SHOWING image for variant:', variantId);
        image.classList.remove('hidden');
      } else {
        // Hide images for other variants
        console.log('[Metafield Images] ✗ HIDING image with variant ID:', imageVariantId);
        image.classList.add('hidden');
      }
    });

    // Also update metafield images in the modal
    const sectionId = gallery.id.replace('GalleryViewer-', '');
    const modal = document.querySelector(`#ProductModal-${sectionId}`);
    if (modal) {
      const modalMetafieldImages = modal.querySelectorAll('[data-metafield-image="true"]');
      console.log('[Metafield Images] Found modal metafield images:', modalMetafieldImages.length);

      modalMetafieldImages.forEach((image) => {
        const imageVariantId = image.dataset.variantId;

        if (imageVariantId === String(variantId)) {
          console.log('[Metafield Images] ✓ SHOWING modal image for variant:', variantId);
          image.classList.remove('hidden');
        } else {
          console.log('[Metafield Images] ✗ HIDING modal image with variant ID:', imageVariantId);
          image.classList.add('hidden');
        }
      });
    }

    // Re-attach click handlers to newly visible thumbnails
    const thumbnailsContainer = gallery.querySelector('[id^="GalleryThumbnails"]');
    if (thumbnailsContainer) {
      const visibleMetafieldThumbnails = thumbnailsContainer.querySelectorAll('[data-metafield-image="true"]:not(.hidden)');
      visibleMetafieldThumbnails.forEach((thumbnail) => {
        const button = thumbnail.querySelector('button');
        if (button && thumbnail.dataset.target) {
          // Remove existing listener if any
          button.replaceWith(button.cloneNode(true));
          const newButton = thumbnail.querySelector('button');
          newButton.addEventListener('click', function() {
            const mediaId = thumbnail.dataset.target;
            // Trigger the gallery's setActiveMedia method
            if (gallery.setActiveMedia) {
              gallery.setActiveMedia(mediaId, false);
            }
          });
        }
      });
    }

    // Update slider if it exists - need to reset pages to recalculate visible items
    const viewer = gallery.querySelector('[id^="GalleryViewer"]');
    if (viewer) {
      // Reset pages to recalculate which items should be shown
      if (typeof viewer.resetPages === 'function') {
        viewer.resetPages();
      } else if (viewer.slider && typeof viewer.slider.resetPages === 'function') {
        viewer.slider.resetPages();
      }

      // Also update thumbnails slider
      const thumbnailsContainer = gallery.querySelector('[id^="GalleryThumbnails"]');
      if (thumbnailsContainer) {
        if (typeof thumbnailsContainer.resetPages === 'function') {
          thumbnailsContainer.resetPages();
        }
      }
    }
  }

  // Initialize click handlers for metafield thumbnails that are visible on page load
  function initializeMetafieldThumbnails() {
    const mediaGalleries = document.querySelectorAll('media-gallery');
    mediaGalleries.forEach((gallery) => {
      const thumbnailsContainer = gallery.querySelector('[id^="GalleryThumbnails"]');
      if (thumbnailsContainer) {
        const visibleMetafieldThumbnails = thumbnailsContainer.querySelectorAll('[data-metafield-image="true"]:not(.hidden)');
        visibleMetafieldThumbnails.forEach((thumbnail) => {
          const button = thumbnail.querySelector('button');
          if (button && thumbnail.dataset.target) {
            button.addEventListener('click', function() {
              const mediaId = thumbnail.dataset.target;
              if (gallery.setActiveMedia) {
                gallery.setActiveMedia(mediaId, false);
              }
            });
          }
        });
      }
    });
  }

  // Subscribe to variant change events when the script loads
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    console.log('[Metafield Images] Script loaded, subscribing to variant changes');
    // Subscribe to both events to ensure we catch variant changes
    subscribe(PUB_SUB_EVENTS.variantChange, handleVariantChange);
    subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, handleVariantChange);
    console.log('[Metafield Images] Subscribed to both variantChange and optionValueSelectionChange events');

    // Initialize thumbnails on page load
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeMetafieldThumbnails);
    } else {
      initializeMetafieldThumbnails();
    }
  } else {
    console.error('[Metafield Images] Could not subscribe - subscribe or PUB_SUB_EVENTS not available');
  }
})();
